// decorators/applyMiddleware.ts
import { allOperationDefinitions } from "../metadata/metaDataStore.js";
function applyMiddleware(middleware) {
  return (target, propertyName) => {
    const isStatic = target.constructor === Function;
    const currentFields = isStatic ? allOperationDefinitions() : target.fields;
    if (!currentFields)
      throw new Error(
        "Cannot applyMiddleware to non defined field. Please use @applyMiddleware after (=== above) @Field"
      );
    const field = currentFields[propertyName] ?? currentFields[propertyName + "_prop"];
    if (!field)
      throw new Error(
        "Cannot applyMiddleware to non defined field. Please use @applyMiddleware after (=== above) @Field"
      );
    field.middlewares.push(middleware);
  };
}
export {
  applyMiddleware
};
